const TerminalTransactions = () => {
	return <div>TerminalTransactions</div>;
};

export default TerminalTransactions;
